import React, { useEffect } from 'react';
import './ImageModal.css';

export const ImageModal = ({ isOpen, onClose, imageSrc, alt }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="image-modal-overlay" onClick={onClose}>
      <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="image-modal-close" onClick={onClose} aria-label="Close image">×</button>
        <div className="image-modal-body">
          <img src={imageSrc} alt={alt || 'Image preview'} className="image-modal-img" />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;